import { FormSearchField } from "@pharmupp/p3-front-commons"
import { teamFunctionReferential } from "../../../../../../referential"
import { fields } from "../../GeneralInfos.fields"
import { isTeamFunctionRequired } from "../../GeneralInfos.rg"
import { useGetUserTypeField } from "../useGetUserTypeField"

export const ConditionalTeamFunctionField = () => {
  const type = useGetUserTypeField()

  if (!isTeamFunctionRequired(type)) {
    return null
  }

  return (
    <FormSearchField
      label="Fonction"
      name={fields.teamFunction}
      options={teamFunctionReferential}
      valueFormat="optionValue"
      keepOriginalOrder
      required
    />
  )
}
